<script>
import FormFieldBase from '../../FormFieldBase'

export default {
    extends: FormFieldBase,
    props: {
        inputPrepend: {
            type: [String, Number, Object],
            default() {
                return {
                    component: 'i',
                    attrs: {class: 'fa fa-lock'}
                }
            }
        },
        iconShowPassword: {
            type: String,
            default: 'fa fa-eye'
        },
        iconHidePassword: {
            type: String,
            default: 'fa fa-eye-slash'
        }
    },
    computed: {
        processedInputAttrs() {
            let attrs = FormFieldBase.computed.processedInputAttrs.call(this)

            attrs.input = this.passwordComponent

            if( attrs.autocomplete === undefined ) {
                attrs.autocomplete = 'new-password'
            }

            return attrs
        },
        $_inputAppend() {
            return {
                component: 'i',
                attrs: {class: ['show-pass', this.passwordIcon], title: 'Show password'},
                on: {mousedown: this.showPassword, mouseleave: this.hidePassword, mouseup: this.hidePassword}
            }
        },
        $_inputDebounce() {
            return 0
        }
    },
    data() {
        return {
            passwordComponent: 'oc-password-input',
            passwordIcon: this.iconShowPassword
        }
    },
    methods: {
        showPassword(e) {
            this.passwordIcon = this.iconHidePassword
            this.passwordComponent = 'oc-text-input'
        },
        hidePassword(e) {
            this.passwordIcon = this.iconShowPassword
            this.passwordComponent = 'oc-password-input'
        }
    }
}
</script>

<style scoped>
    .required-asterisk {
        color:red;
    }
    .form-group .input-group .form-control {
        height: auto;
    }
    .form-group .form-field-help-question {
        color: #b1b1b1 !important;
        text-indent: 2px;
        font-size:15px;
        vertical-align: baseline;
    }

    .hide-input-feedback.form-control.is-valid,
    .hide-input-feedback.form-control.is-invalid {
        background-image: none;
        padding: 6px 12px;
    }

    .hide-input-group-sm .input-feedback.form-control.is-valid,
    .hide-input-group-sm .input-feedback.form-control.is-invalid {
        padding: .25rem .5rem;
    }

    /* password styles */
    .input-group-append .input-group-text {
        background: none;
    }

    i.show-pass {
        cursor: pointer;
        color: #bbb;
    }
</style>
